import React, { useState } from "react";
import Modal from "react-modal";
import "../css/SelectJobModal.css";

const SingleValueInput = ({ theme, header, inputTag, isOpen, setIsOpen, returnData }) => {

    const [value, setValue] = useState(null);
    const [error, setError] = useState("");

    const handleSubmit = () => {
        if (!value) {
            setError("No value entered!");
        } else {
            setError("");

            returnData(value);
            setIsOpen(false);
        }
    };

    return (
        <Modal
        id={theme}
            isOpen={isOpen}
            onRequestClose={() => setIsOpen(false)}
            ariaHideApp={false}
            style={{
                overlay: {
                    zIndex: 99999,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                },
                content: {
                    margin: "auto",
                    justifyContent: "center",
                    display: "flex",
                    backgroundColor: "transparent",
                    border: "none",
                    zIndex: 100000,
                    height: "300px",
                }
            }}
        >
            <div className={`${theme} modal-container`}>
                <h2>{header}</h2>

                <div className="manual-inputs">
                    <label htmlFor="value">{inputTag}</label>
                    <input
                        id="value"
                        type="text"
                        className="input"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                    />

                </div>

                {error && <p className="error-message">{error}</p>}

                <div className="button-group">
                    <button className="add-button" onClick={handleSubmit}>
                        Submit
                    </button>
                    <button
                        className="close-button"
                        onClick={() => setIsOpen(false)}
                    >
                        Close
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default SingleValueInput;
